<template>
  <v-card class="mb-4 support-card" outlined>
    <v-card-text class="pa-6">
      <div class="d-flex align-center">
        <v-icon color="success" class="mr-2">mdi-whatsapp</v-icon>
        <h3 class="support-title">Suporte especializado</h3>
      </div>

      <p class="mt-2 mb-4">
        Nossa equipe está pronta para ajudar você a começar com o pé direito.
      </p>

      <v-btn outlined color="primary" @click="getHelp()">
        <v-icon left color="success">mdi-whatsapp</v-icon>
        Falar no WhatsApp
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  methods: {
    getHelp() {
      let link = `https://api.whatsapp.com/send?phone=+${process.env.VUE_APP_SUPPORT_WHATSAPP}`;

      let msg = "&text=Olá, Preciso de ajuda!";

      window.open(link + msg);
    },
  },
};
</script>

<style scoped>
.support-card {
  border-radius: 20px !important;
  border-color: #ece7f8 !important;
  background: linear-gradient(135deg, #fbfaff 0%, #f3effd 100%);
}

.support-title {
  color: var(--v-primary-base);
  font-weight: 700;
}
</style>
